import {
    IGestaoProdutosVinculados,
    IProdutoEquipe,
} from "../../../Interfaces/Vendas/GestaoProdutoVinculados/GestaoProdutosVinculadosInterface";
import {
    DeletaEquipeVendasProdutoService,
    DeletarProdutoEquipeVendaService,
    InsereEquipeVendasProdutoService,
    ListarProdutosDesvinculadosService,
    ListarProdutosVinculadosService,
    VincularProdutoEquipeVendaService,
} from "../../../Services/Vendas/GestaoProdutosVinculados/GestaoProdutosVinculadosService";
import { Controller } from "../../Controller";

export async function ListarProdutosVinculadosPorVendaController(
    idEquipeVendas: number
) {
    return Controller(ListarProdutosVinculadosService(idEquipeVendas));
}

export async function ListarProdutosDesvinculadosPorVendaController(
    idEquipeVendas: number
) {
    return Controller(ListarProdutosDesvinculadosService(idEquipeVendas));
}

export async function InsereEquipeVendasProdutoController(
    requestBody: IGestaoProdutosVinculados
) {
    return Controller(InsereEquipeVendasProdutoService(requestBody));
}
export async function DeletaEquipeVendasProdutoController(
    idEquipeVendasProduto: number
) {
    return Controller(DeletaEquipeVendasProdutoService(idEquipeVendasProduto));
}
export async function DeletarProdutoEquipeVendaController(
    requestBody: IProdutoEquipe
) {
    return Controller(DeletarProdutoEquipeVendaService(requestBody));
}
export async function VincularProdutoEquipeVendaController(
    requestBody: IProdutoEquipe
) {
    return Controller(VincularProdutoEquipeVendaService(requestBody));
}
